// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__4Al4l","header":"MergedInvoice_header__2purw"};